import React from "react";
import DashboardCount from "./dashboard/DashboardCount";

function Dashboard() {
  return (
    <div>
      <DashboardCount />
    </div>
  );
}

export default Dashboard;
